import { SearchParams } from '@/types/common'
import { queryStringify } from '@/ultils'
import axiosClient from '../axiosClient'

const controllerDataConfigApi = {
  getAll(searchParams: SearchParams = {}) {
    const url = `/api/Controller/${searchParams.interfaceId}`
    return axiosClient.get(url + queryStringify(searchParams))
  },
  getByLocationId(searchParams: SearchParams = {}) {
    const url = `/api/Controller/${searchParams.interfaceId}/get-by-location`
    return axiosClient.get(url + queryStringify(searchParams))
  },
}

export default controllerDataConfigApi
